import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/healthz")({
	component: RouteComponent,
});

function RouteComponent() {
	return <>OK</>;
}
